import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import * as DatiRCP from '../DatiRCP';
import {
    BaseComponent,
    BottoneAPI,
    ChiamaAPI,
    DocumentHocComponent,
    PolizzaApprovazione,
    Tipo,
    Trad
} from '../components/';
import {Document, Page, pdfjs} from 'react-pdf';
import moment from 'moment';
import ChiamaWeb, { CChiamaWebParametri } from "../ChiamaWeb";

pdfjs.GlobalWorkerOptions.workerSrc = 'pdf.worker.min.js';

interface IRCPPolizzaState {
    NumeroPagine: number;
    PaginaCorrente: number;
    URLPDF: string;
    Rotazione: any;
    StatoPolizza: string;
    TipoProdotto: string;
    TipoRamo: string;
    Polizza: string;
    Tipi: { [T: string]: Dati.TDictTipo };
    ListaPolizzaApprovazioneJSON: Glob.DatiJSON;
    in1: string;
    in1Abl: boolean;
    in2: string;
    in2Abl: boolean;
    in3: string;
    in3Abl: boolean;
    in4: string;
    in4Abl: boolean;
    ID_TipoPolizzaStato: string;
    ID_TipoProdotto: number;
    ID_Binder: number;
    ID_BinderCompagnia: number;
    Aggiorna: number;
    ID_AnagPOS: number;
    Motivazione: string;
    MotivazioneAnnullamento: string;
    DataEmissione?:Date;
    GiorniEmissione?:number;
    TipologiaAnnullamento:number;
    ID_File: number;
    FirstName: string;
    LastName: string;
    DocType: string;
    DocNumber: string;
    Phone: string;
    Email: string;
    PolicyFileState: string;
    PolicyFileData: string;
    Intermediary: any;
    IgnoreDuplicates: boolean;
}

export class RCPPolizza extends BaseComponent<Glob.IRouteGlobaleProps, IRCPPolizzaState> {

    private _Loading = <img src="/images/loadingBig.gif" />;
    private _ID_Polizza: number = 0;
    private _ID_Anag: number = 0;
    private _Cifra1: string = "0";
    private _Cifra2: string = "0";
    private _RichiestaCasella: string = "";

    private _FileDIP: Glob.DatiJSON = "{}";

    constructor(props: any) {
        super(props);
        this.state = {
            NumeroPagine: 0,
            PaginaCorrente: 1,
            URLPDF: "",
            Rotazione: 0,
            StatoPolizza: "Preventivo di polizza",
            TipoProdotto: "",
            TipoRamo: "",
            Polizza: "",
            Tipi: {},
            ListaPolizzaApprovazioneJSON: "[]",
            in1: "",
            in1Abl: true,
            in2: "",
            in2Abl: true,
            in3: "",
            in3Abl: true,
            in4: "",
            in4Abl: true,
            ID_TipoPolizzaStato: "",
            ID_TipoProdotto: 0,
            ID_Binder: 0,
            ID_BinderCompagnia: 0,
            Aggiorna: 1,
            ID_AnagPOS: 0,
            Motivazione: "",
            MotivazioneAnnullamento: "",
            GiorniEmissione: 31,
            TipologiaAnnullamento: 1,
            ID_File: 0,
            FirstName: "",
            LastName: "",
            DocType: "",
            DocNumber: "",
            Phone: "",
            Email: "",
            PolicyFileState: "",
            PolicyFileData: "",
            Intermediary: undefined,
            IgnoreDuplicates: false
        }
        this.OnDocumentLoad = this.OnDocumentLoad.bind(this);
        this.OnChange = this.OnChange.bind(this);
        this.OnErrore = this.OnErrore.bind(this);
        this.OnClickSalvaAggiornamento = this.OnClickSalvaAggiornamento.bind(this);
        this._ID_Anag = (this.props.match.params as any).ID_Anag;
        this._ID_Polizza = (this.props.match.params as any).ID_Polizza;
    }

    componentDidMount(){
    }
    
    private OnApiError = (error: Error) => {
        Glob.InfoModaleError(Trad.Trad("ERRORE"), error.message);
    };
    
    private DownloadPolicyFile() {
        let url: string = "/api/File/GetPolicyFile"; //URL DI BASE
        url += "?sessione=" + Glob.GetSessione().Sessione; //ID SESSIONE UTENTE
        url += "&idPolicy=" + this._ID_Polizza; //ID POLIZZA
        url += "&idTypeProduct=" + this.state.ID_TipoProdotto;//ID TIPO PRODOTTO
        url += "&idBinderCompany=" + this.state.ID_BinderCompagnia;//ID BINDER COMPAGNIA
        url += "&idTypePolicyState=" + this.state.ID_TipoPolizzaStato; //ID TIPO POLIZZASTATO
        url += "&isJson=true"; //Tipo di stampa JSON
        url += "&isFile=false"; //Non voglio il download del file ma solo il suo path completo
        
        const Param: CChiamaWebParametri = {
            URL: "/api/File/GetPolicyFile",
            Metodo: "POST",
            OnRis: (sender, data) => this.OnDownloadPolicyFile(sender, data),
            OnInvio: () => this.GetPolicyFileData(),
            OnErrore: (sender: ChiamaWeb, error: Error) => this.OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    }
    
    private OnDownloadPolicyFile(sender: ChiamaWeb, data: Dati.CDatiPolicyFile)
    {
        if (data.State != "" && data.State != undefined)
        {
            this.setState({
                ID_File: data.ID_File,
                PolicyFileData: data.Data,
                PolicyFileState: data.State,
                FirstName: data.FirstName,
                LastName: data.LastName,
                DocType: data.DocType,
                DocNumber: data.DocNumber,
                Phone: data.Phone,
                Email: data.Email,
                URLPDF: data.Link
            });
        }
        else {
            this.setState({
                ID_File: data.ID_File,
                PolicyFileData: data.Data,
                FirstName: data.FirstName,
                LastName: data.LastName,
                DocType: data.DocType,
                DocNumber: data.DocNumber,
                Phone: data.Phone,
                Email: data.Email,
                URLPDF: data.Link
            });  
        }
    }
    
    private GetPolicyFileData(): any {
        let request = new Dati.CDatiRequestPolicyFile();
        request.ID_Anag = this._ID_Anag;
        request.ID_Polizza = this._ID_Polizza;
        request.ID_TipoProdotto = this.state.ID_TipoProdotto;
        request.ID_BinderCompagnia = this.state.ID_BinderCompagnia;
        request.ID_TipoPolizzaStato = this.state.ID_TipoPolizzaStato;

        return request;
    }
    
    private OnSendPolicyToSignature(): any {
        let request = new Dati.CDatiRequestDigitalSignature();

        request.PolicyFile = this.GetPolicyFileData();
        request.Polizza = this.state.Polizza;
        request.FirstName = this.state.FirstName;
        request.LastName = this.state.LastName;
        request.DocType = this.state.DocType;
        request.DocNumber = this.state.DocNumber;
        request.Phone = this.state.Phone;
        request.Email = this.state.Email;
        
        let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
        let PHONE_REGEXP = /^\+?[1-9]\d{1,14}$/;

        if (!request.FirstName || request.FirstName.length <= 2) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad("FirstName is not valid"));
            return null;
        }
        
        if (!request.LastName || request.LastName.length <= 2) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad("LastName is not valid"));
            return null;
        }

        if (!request.DocType || request.DocType.length <= 3 || !request.DocNumber || request.DocNumber.length <= 3) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad("Document is not valid"));
            return null;
        }
        
        if (!request.Email || request.Email.length <= 5 || !EMAIL_REGEXP.test(request.Email)) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad("Email is not valid"));
             return null;
        }
        
        if (!request.Phone || request.Phone.length < 9 || !PHONE_REGEXP.test(request.Phone)) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad("Phone is not valid"));
            return null;
        }
        
        if (!request.Phone.startsWith('+'))
        {
            request.Phone = '+39' + request.Phone;
        }
        return request;
    }
    
    private OnDocumentLoad(pagine: number): void {
        this.setState({ NumeroPagine: pagine });
    }
    
    public PdfViewer(): any {
        return <div className="kt-demo__preview kt-demo__preview--btn">
            <Document file={`data:application/pdf;base64,${this.state.PolicyFileData}`}
                      onLoadSuccess={(p) => {this.OnDocumentLoad(p.numPages)}}
                      onLoadError={console.error}
                      loading={this._Loading} 
                      rotate={this.state.Rotazione}>
                <Page pageNumber={this.state.PaginaCorrente} width={window.innerHeight}/>
            </Document>
        </div>
    }

    public OnPaginaAvanti(e: React.FormEvent<any>): void {
        e.preventDefault();
        if (this.state.PaginaCorrente < this.state.NumeroPagine) {
            this.setState({ PaginaCorrente: this.state.PaginaCorrente + 1 });
        }
    }

    public OnPaginaIndietro(e: React.FormEvent<any>): void {
        e.preventDefault();
        if (this.state.PaginaCorrente > 1) {
            this.setState({ PaginaCorrente: this.state.PaginaCorrente - 1 });
        }
    }

    public OnPaginaFine(e: React.FormEvent<any>): void {
        e.preventDefault();
        this.setState({ PaginaCorrente: this.state.NumeroPagine });
    }

    public OnPaginaInizio(e: React.FormEvent<any>): void {
        e.preventDefault();
        this.setState({ PaginaCorrente: 1 });
    }

    public OnRuota(e: React.FormEvent<any>): void {
        e.preventDefault();
        let rotate: number = this.state.Rotazione + 90;
        if (rotate >= 360) {
            rotate = 0;
        }
        this.setState({ Rotazione: rotate });
    }
    
    private static dataURItoBlob(dataURI: string) {
        const byteString = window.atob(dataURI);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        return new Blob([int8Array], {type: 'application/pdf'});
    }
    
    public OnPrint(e: React.FormEvent<any>): void {
        e.preventDefault();
        const blob = RCPPolizza.dataURItoBlob(this.state.PolicyFileData);
        const url = URL.createObjectURL(blob);

        window.open(url, '_blank');
    }
    
    private abilitaCampiCartaServizi(campo: string) {
        switch (campo) {
            case "1":
                this.setState({ in1Abl: false });
                break;
            case "2":
                this.setState({ in2Abl: false });
                break;
            case "3":
                this.setState({ in3Abl: false });
                break;
            case "4":
                this.setState({ in4Abl: false });
                break;
        }
    }

    private recuperaCifra(cifra: string): string {
        switch (cifra) {
            case "1":
                return this.state.in1;
            case "2":
                return this.state.in2;
            case "3":
                return this.state.in3;
            case "4":
                return this.state.in4;
            default:
                return "";
        }
    }

    private emettiURL(): string {
        let URL: string = "/api/polizza/EmissioneCartaServiziRCP";
        URL += "?id_Polizza=" + this._ID_Polizza.toString();
        URL += "&cifra1=" + this.recuperaCifra(this._Cifra1);
        URL += "&cifra2=" + this.recuperaCifra(this._Cifra2);
        URL += "&ignoreDuplicates=" + this.state.IgnoreDuplicates;
        return URL;
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIDatoTipiInfo_Polizza, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (!dati.Errore) {
                let DatiPolizza: DatiRCP.RCPPolizza = new DatiRCP.RCPPolizza();
                DatiPolizza = JSON.parse(dati.Dato.DatiPolizza);
                let Polizze: DatiRCP.CProdotto[] = DatiPolizza.Polizze;
                let ID_Binder: number = 0;
                let ID_BinderCompagnia: number = 0;

                for (let x: number = 0; x < Polizze.length; x++) {
                    if (Polizze[x].GaranziaBase.Selezionata) {
                        ID_Binder = Polizze[x].ID_Binder;
                        ID_BinderCompagnia = Polizze[x].ID_BinderCompagnia;
                    }
                }

                if (dati.Tipi["RichiesteCartaServizi"].RichiestaCifra1 != undefined && dati.Tipi["RichiesteCartaServizi"].RichiestaCifra2 != undefined) {
                    this._Cifra1 = dati.Tipi["RichiesteCartaServizi"].RichiestaCifra1.Valore;
                    this._Cifra2 = dati.Tipi["RichiesteCartaServizi"].RichiestaCifra2.Valore;
                    this.abilitaCampiCartaServizi(this._Cifra1);
                    this.abilitaCampiCartaServizi(this._Cifra2);
                    this._RichiestaCasella = dati.Tipi["RichiesteCartaServizi"].RichiestaCasella.Valore;
                }
                const demissione = moment(dati.Dato.DataEmissione);
                const now = moment(moment.now());
                this.setState({ StatoPolizza: dati.Dato.StatoPolizza, 
                                TipoProdotto: dati.Dato.TipoProdotto, 
                                TipoRamo: dati.Dato.TipoRamo, 
                                Polizza: dati.Dato.Polizza, 
                                Tipi: dati.Tipi, 
                                ListaPolizzaApprovazioneJSON: dati.Dato.ListaPolizzaApprovazioneJSON, 
                                ID_TipoPolizzaStato: dati.Dato.ID_TipoPolizzaStato, 
                                ID_TipoProdotto: dati.Dato.ID_TipoProdotto, 
                                ID_Binder: ID_Binder, 
                                ID_BinderCompagnia: ID_BinderCompagnia ,
                                DataEmissione: dati.Dato.DataEmissione,
                                Intermediary: dati.Dato.Intermediary,
                                GiorniEmissione: now.diff(demissione,"days")
                            });
                this.DownloadPolicyFile();
            }
            else {
                Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
            }
        }
        return true;
    }

    private OnAggiornaListaApprovazione(sender: BottoneAPI): any {
        var Ingr = new Dati.CIngrAPI<Dati.CPolizzaApprovazioneBase>();
        Ingr.Dato.ID_Polizza = this._ID_Polizza;
        Ingr.Dato.ListaPolizzaApprovazioneJSON = this.state.ListaPolizzaApprovazioneJSON;
        return Ingr;
    }

    private OnClickSalvaAggiornamento(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            Glob.InfoModaleSuccess(Trad.Trad("POLIZZA"), Trad.Trad("Stato aggiornato correttamente"));
            this.setState({ Aggiorna: this.state.Aggiorna + 1 });
        }
    }

    private OnInvioAnnullaPolizza(sender: BottoneAPI): any {
        //console.warn("STATE", this.state);
        //this.RegoleCheck(this.state);
        //return false;
        var Ingr = new Dati.CIngrAPI<Dati.CDatiPolizzaAnnullamento>();
        Ingr.Dato.ID_Polizza = this._ID_Polizza;
        Ingr.Dato.Note = this.state.MotivazioneAnnullamento;

        Ingr.Dato.TipologiaAnnullamento = this.state.TipologiaAnnullamento;
        return Ingr;
    }

    private OnClickAnnullaPolizza(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto) + (dati.ErrTesti.length > 0 ? " - " + dati.ErrTesti.join(", ") : ""));
        }
        else {
            this.setState({ StatoPolizza: Glob.Tipi_PS_AnnullataSEO, Polizza: dati.MessaggioTesto });
            this.setState({ Aggiorna: this.state.Aggiorna + 1 });
            Glob.InfoModaleSuccess("Info", Trad.Trad("Polizza annullata correttamente"));
        }
    }

    private OnClickEmetti(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto) + (dati.ErrTesti.length > 0 ? " - " + dati.ErrTesti.join(", ") : ""));
        }
        else {
            //let app = this.state.;
            this.setState({ StatoPolizza: Glob.Tipi_PS_Emessa, Polizza: dati.MessaggioTesto })
            //app.Dato.Polizza = dati.MessaggioTesto;
            //app.Dato.StatoPolizza = "Polizza emessa";
            //this.setState({ Dato: app });
            this.setState({ Aggiorna: this.state.Aggiorna + 1 });
            Glob.InfoModaleSuccess("Info", Trad.Trad("Polizza emessa correttamente"));
        }
    }

    private bloccoInput(blocco: boolean): string {
        if (blocco) {
            return " cartaservizibloccata";
        }
        else {
            return "";
        }
    }

    private OnClickConsolidaSottoscrittore(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            Glob.InfoModaleSuccess(Trad.Trad("POLIZZA"), Trad.TradParam("Preventivo di polizza {1-S} sottoposto al sottoscrittore correttamente", [this._ID_Polizza]));
            this.setState({ ID_TipoPolizzaStato: Glob.Tipi_PS_ConsolidataSottoscrittore, Aggiorna: this.state.Aggiorna + 1 });
        }
    }
    
    private OnClickCancel(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            Glob.InfoModaleSuccess(Trad.Trad("POLIZZA"), Trad.TradParam("Preventivo cancellato correttamente con ID: {1-S}", [this._ID_Polizza]));
            this.props.history.push("/");
        }
    }
    
    private OnClickTermination(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            Glob.InfoModaleSuccess(Trad.Trad("POLIZZA"), Trad.TradParam("Polizza disdettata correttamente con ID: {1-S}", [this._ID_Polizza]));
            this.props.history.push("/");
        }
    }
    
    private OnClickSendPolicyToSignature(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto) + (dati.ErrTesti.length > 0 ? " - " + dati.ErrTesti.join(", ") : ""));
        }
        else {
            this.setState({ PolicyFileState: Glob.Tipi_FS_Inviato })
            this.setState({ Aggiorna: this.state.Aggiorna + 1 });
            Glob.InfoModaleSuccess("Info", Trad.Trad("Richiesta per la firma digitale inviata correttamente"));
        }
    }

    private OnClickCancelSignature(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto) + (dati.ErrTesti.length > 0 ? " - " + dati.ErrTesti.join(", ") : ""));
        }
        else {
            this.setState({ PolicyFileState: "" })
            this.setState({ Aggiorna: this.state.Aggiorna + 1 });
            Glob.InfoModaleSuccess("Info", Trad.Trad("Richiesta per la firma digitale cancellata correttamente"));
        }
    }
    
    public render() {
        var content: any;
        var maxGiorniAnnullamento = 0;
        const gruppi = Glob.GetSessione().Gruppi;

        let isUnderwriter: boolean = false;
        if (gruppi.indexOf("G&T")!=-1 || gruppi.indexOf("16")!=-1)
            isUnderwriter = true;
        
        if (gruppi.length>0){
            if (gruppi.indexOf("9")!=-1)
                //junior 7 giorni
                maxGiorniAnnullamento = 7;
            else
                if (gruppi.indexOf("8")!=-1 || gruppi.indexOf("7")!=-1)
                    maxGiorniAnnullamento = 20;
                else
                    if (gruppi.indexOf("G&T")!=-1 || gruppi.indexOf("16")!=-1)
                        maxGiorniAnnullamento = 30;
        }
        //maxGiorniAnnullamento=100;
        if (this.state.URLPDF == "") {
            content = this._Loading;
        } else {
            content = this.PdfViewer();
        }

        let approvatore: boolean = false;;
        let ListaApprovazioni: Dati.CPolizzaApprovazione[] = JSON.parse(this.state.ListaPolizzaApprovazioneJSON);

        for (let i: number = 0; i < Glob.GetSessione().Gruppi.length; i++) {
            if (ListaApprovazioni.findIndex(a => a.CommentiGruppi[Glob.GetSessione().Gruppi[i]] != undefined) >= 0)
                approvatore = true;
        }
        console.log(Glob.GetSessione().Gruppi);
        let ParametriAssociaPolizzaAPOS: { [Param: string]: any } = [];
        ParametriAssociaPolizzaAPOS["id_Polizza"] = this._ID_Polizza*1;
        ParametriAssociaPolizzaAPOS["id_AnagPOS"] = this.state.ID_AnagPOS*1;
        ParametriAssociaPolizzaAPOS["motivazione"] = this.state.Motivazione;

        let Permesso_PS_Consolidata: string[];
        if (this.state.Tipi != undefined && this.state.Tipi.PolizzaStato != undefined && this.state.Tipi.PolizzaStato[Glob.Tipi_PS_Consolidata] != undefined)
            Permesso_PS_Consolidata = this.state.Tipi.PolizzaStato[Glob.Tipi_PS_Consolidata].Permesso || [];
        else
            Permesso_PS_Consolidata = [];
        

        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-glasses"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad(this.state.TipoRamo)} - {Trad.Trad(this.state.TipoProdotto)} - {Trad.Trad(this.state.StatoPolizza)}
                        </h3>
                    </div>
                </div>
                <div className="portlet__head-tools">
                    <ul className="kt-portlet__nav">
                        <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                            <h4 className="kt-portlet__head-label">
                                {this.state.Polizza}
                            </h4>
                        </div>
                    </ul>
                </div>
            </div>
            <form className="kt-form login-form kt-form login-form--label-align-right kt-form login-form--state-" id="kt_form" noValidate>
                <div className="kt-portlet__body">
                    <div className="kt-section">
                        <span className="kt-section__heading text-center">
                            <div className="divtabella">
                                <a href="#" className="btn btn-success kt-btn kt-btn--icon btn--icon-only" onClick={(e) => { this.OnPaginaInizio(e); }}>
                                    <i className="fa fa-fast-backward"></i>
                                </a>
                            </div>
                            <div className="divtabella">
                                <a href="#" className="btn btn-info kt-btn kt-btn--icon btn--icon-only" onClick={(e) => { this.OnPaginaIndietro(e); }}>
                                    <i className="fa fa-chevron-left"></i>
                                </a>
                            </div><div className="divtabella">
                                <a href="#" className="btn btn-info kt-btn kt-btn--icon btn--icon-only" onClick={(e) => { this.OnPaginaAvanti(e); }}>
                                    <i className="fa fa-chevron-right"></i>
                                </a>
                            </div>
                            <div className="divtabella">
                                <a href="#" className="btn btn-success kt-btn kt-btn--icon btn--icon-only" onClick={(e) => { this.OnPaginaFine(e); }}>
                                    <i className="fa fa-fast-forward"></i>
                                </a>
                            </div>
                            <div className="divtabella">
                                <a href="#" className="btn btn-metal kt-btn kt-btn--icon btn--icon-only" onClick={(e) => { this.OnRuota(e); }}>
                                    <i className="fa fa-redo"></i>
                                </a>
                            </div>
                            <div className="divtabella">
                                <a href="#" target="_new" className="btn btn-warning kt-btn kt-btn--icon btn--icon-only" onClick={(e) => { this.OnPrint(e); }}>
                                    <i className="fa fa-print"></i>
                                </a>
                            </div>
                            <div className="divtabella">
                                {this.state.PaginaCorrente} / {this.state.NumeroPagine}
                            </div>
                        </span>
                        <div className="kt-section__content text-center">
                            <p id="kt_blockui_1_content text-center">
                                {content}
                            </p>
                            <PolizzaApprovazione Id="ListaPolizzaApprovazioneJSON" Name="ListaPolizzaApprovazioneJSON" Dati={this.state.ListaPolizzaApprovazioneJSON} TipiPolizzaApprovazione={this.state.Tipi["PolizzaApprovazione"]} OnChange={(e, v) => this.OnChange(e, v)} Visibile={Glob.GetSessione().Autorizzazioni['PolizzaApprovazioneCommenti'] > 0} />
                        </div>
                        <div className="kt-section__content text-left">
                            <div className="form-group kt-form login-form__group text-center row">
                                <div className={Glob.DimensioneCSS(12)}>
                                    <DocumentHocComponent Label={Trad.Trad("SetInformativo")}
                                        SpecialInformationEnabled={false}
                                        GetListURL={"/api/Document/GetBinderProductFile?id_BinderCompagnia=" + this.state.ID_BinderCompagnia + "&id_TipoProdotto=" + this.state.ID_TipoProdotto} />
                                </div>
                            </div>
                            <div className={Glob.GetSessione().Autorizzazioni['AssociaPolizzaAPOS'] != 2 ? "hidden" : "form-group kt-form login-form__group row"}>
                                <div className={Glob.DimensioneCSS(12)}>
                                    <div className="drop-document kt-portlet kt-portlet--height-fluid">
                                        <div className="kt-portlet__head">
                                            <div className="kt-portlet__head-label">
                                                <h3 className="kt-portlet__head-title">{Trad.Trad("Operazioni")}</h3>
                                            </div>
                                        </div>
                                        <div className="kt-portlet__body">
                                            <div className="kt-widget4">
                                                <div className="row mb-3 pb-3" style={{borderBottom: "1px dashed #ebedf2"}}>
                                                    <div className={Glob.DimensioneCSS(2)}>
                                                        {Trad.Trad("AssociaPolizzaAPOS")}
                                                    </div>
                                                    <div className={Glob.DimensioneCSS(4)}>
                                                        <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                                              Campo={"ID_AnagPOS"}
                                                              ID_Chiave={this.state.ID_AnagPOS}
                                                              OnAggiorna={(e, v) => {
                                                                  this.OnChange(e, v)
                                                              }} TradValori LinkSelezione="/anagrafica/" />
                                                    </div>
                                                    <div className={Glob.DimensioneCSS(4)}>
                                                        <textarea className="form-control" name="Motivazione" value={this.state.Motivazione} rows={2} onChange={this.OnChange}/>
                                                    </div>
                                                    <div className={Glob.DimensioneCSS(2)}>
                                                        <BottoneAPI Attivo={this.state.ID_TipoPolizzaStato != Glob.Tipi_PS_Emessa}
                                                                    Alt={Trad.Trad("Associa")}
                                                                    Icona="fa fa-exchange-alt"
                                                                    Testo={Trad.Trad("Associa")}
                                                                    ClasseAttivo="btn btn-warning"
                                                                    ClasseAttesa="btn kt-btn btn-warning kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                                    URL="/api/polizza/AssociaPolizzaAPOS"
                                                                    Metodo="POST"
                                                                    OnClick={(s, d) => this.OnClickSalvaAggiornamento(s, d)}
                                                                    ParamURLLista={ParametriAssociaPolizzaAPOS} />
                                                    </div>
                                                </div>
                                                <div className="row mb-3 pb-3" style={{borderBottom: "1px dashed #ebedf2"}}>
                                                    <div className={Glob.DimensioneCSS(12)}>
                                                        {Trad.Trad("IgnoreDuplicates")}
                                                        <div className="kt-radio-list">
                                                            <div className="row ml-1">
                                                                <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                                                    <input name="rdoSi" type="radio"
                                                                           checked={this.state.IgnoreDuplicates} onClick={() => {
                                                                        this.setState({IgnoreDuplicates: true})
                                                                    }}/>{Trad.Trad("Si")} <span/>
                                                                </label>
                                                                <label className="kt-radio kt-radio--solid kt-radio--state-success ml-4">
                                                                    <input name="rdoNo" type="radio"
                                                                           checked={!this.state.IgnoreDuplicates} onClick={() => {
                                                                        this.setState({IgnoreDuplicates: false});
                                                                    }}/>{Trad.Trad("No")}<span/>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {(this.state.ID_TipoPolizzaStato=="PS-Emessa" || this.state.ID_TipoPolizzaStato=="PS-EmessaFirmata") && this.state.GiorniEmissione!<maxGiorniAnnullamento?
                                                    <div className="row mb-3 pb-3" style={{borderBottom: "1px dashed #ebedf2"}}>

                                                        <div className={Glob.DimensioneCSS(2)}>
                                                            {Trad.Trad("AnnullaPolizza")}
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(4)}>
                                                            <div className="kt-radio-list">
                                                                <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                                                    <input name="rdoStornoConImposte" type="radio" checked={this.state.TipologiaAnnullamento == 1} onClick={()=>{this.setState({TipologiaAnnullamento:1})}} />{Trad.Trad("AnnullamentoSeo")}<span></span>
                                                                </label>
                                                                <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                                                    <input name="rdoStornoConImposte" type="radio" checked={this.state.TipologiaAnnullamento == 2} onClick={()=>{this.setState({TipologiaAnnullamento:2})}} />{Trad.Trad("StornoConImposte")}<span></span>
                                                                </label>
                                                                <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                                                    <input name="rdoStornoConImposte" type="radio" checked={this.state.TipologiaAnnullamento == 3} onClick={()=>{this.setState({TipologiaAnnullamento:3})}} />{Trad.Trad("StornoSenzaImposte")}<span></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(4)}>
                                                        <textarea className="form-control"
                                                                  name="Motivazione"
                                                                  value={this.state.MotivazioneAnnullamento}
                                                                  rows={2}
                                                                  onChange={(e)=> this.setState({MotivazioneAnnullamento: e.currentTarget.value})}>

                                                        </textarea>
                                                        </div>

                                                        <div className={Glob.DimensioneCSS(2)}>
                                                            <BottoneAPI
                                                                Attivo={this.state.MotivazioneAnnullamento.trim()!=""} //{this._AbilitaModifica && this.ValidateForm()}
                                                                Alt={Trad.Trad("Procedi")}
                                                                Icona="fa fa-trash"
                                                                Testo={Trad.Trad("Procedi")}
                                                                ClasseAttivo="btn btn-brand"
                                                                ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                                URL="/api/polizza/annullapolizza"
                                                                Metodo="POST"
                                                                OnInvio={s => this.OnInvioAnnullaPolizza(s)}
                                                                OnClick={(s, d) => this.OnClickAnnullaPolizza(s, d)}
                                                                //OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}
                                                                Visibile={this._Scrittura}

                                                            />
                                                        </div>
                                                    </div>
                                                    :<div/>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className={this.state.Intermediary == undefined ? "hidden" : "form-group kt-form login-form__group row"}>
                                <div className={Glob.DimensioneCSS(12)}>
                                    <div className="drop-document kt-portlet kt-portlet--height-fluid">
                                        <div className="kt-portlet__head">
                                            <div className="kt-portlet__head-label">
                                                <h3 className="kt-portlet__head-title">{Trad.Trad("Rete distributiva")}</h3>
                                            </div>
                                        </div>
                                        <div className="kt-portlet__body">
                                            <div className="kt-widget4">
                                                <label>{Trad.Trad("Nome del Intermediario")} : {this.state.Intermediary}</label>  
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            {(this.state.ID_TipoPolizzaStato=="PS-Emessa" || this.state.ID_TipoPolizzaStato=="PS-EmessaFirmata") ?
                                <div className="form-group kt-form login-form__group row">
                                    <div className={Glob.DimensioneCSS(12)}>
                                        <div className="drop-document kt-portlet kt-portlet--height-fluid">
                                            <div className="kt-portlet__body">
                                                <div className="kt-widget4">
                                                        <>
                                                            <div className="row ">
                                                                <div className={Glob.DimensioneCSS(2)}>
                                                                    {Trad.Trad("FirmaDigitale")}<br/><br/>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(4)}>
                                                                    <label>{Trad.Trad("Nome")}</label>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(4)}>
                                                                    <label>{Trad.Trad("Cognome")}</label>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(2)}/>
                                                            </div>
                                                            <div className="row ">
                                                                <div className={Glob.DimensioneCSS(2)}>
                                                                    <label>{Trad.Trad("Il contraente/Legale rappresentante")}</label>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(4)}>
                                                                    <input type="text"
                                                                           className="form-control"
                                                                           name="FirstName"
                                                                           value={this.state.FirstName}
                                                                           onChange={(e)=> this.setState({FirstName: e.currentTarget.value})}>
                                                                    </input>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(4)}>
                                                                    <input type="text"
                                                                           className="form-control"
                                                                           name="LastName"
                                                                           value={this.state.LastName}
                                                                           onChange={(e)=> this.setState({LastName: e.currentTarget.value})}>
                                                                    </input>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(2)}/>
                                                            </div>
                                                            <div className="row ">
                                                                <div className={Glob.DimensioneCSS(2)}>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(4)}>
                                                                    <label>{Trad.Trad("Tipo Documento")}</label>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(4)}>
                                                                    <label>{Trad.Trad("Numero documento")}</label>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(2)}>
                                                                </div>
                                                            </div>
                                                            <div className="row ">
                                                                <div className={Glob.DimensioneCSS(2)}>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(4)}>
                                                                    <select className="form-control"
                                                                            name="DocType"
                                                                            value={this.state.DocType}
                                                                            onChange={(e)=> this.setState({DocType: e.currentTarget.value})}>
                                                                        <option value=""/>
                                                                        <option value="F-Passaporto">{Trad.Trad("F-Passaporto")}</option>
                                                                        <option value="F-Patente">{Trad.Trad("F-Patente")}</option>
                                                                        <option value="F-CartaIdentita">{Trad.Trad("F-CartaIdentita")}</option>
                                                                    </select>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(4)}>
                                                                    <input type="text"
                                                                           className="form-control"
                                                                           name="DocNumber"
                                                                           value={this.state.DocNumber}
                                                                           onChange={(e)=> this.setState({DocNumber: e.currentTarget.value})}>
                                                                    </input>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(2)}>
                                                                </div>
                                                            </div>
                                                            <div className="row ">
                                                                <div className={Glob.DimensioneCSS(2)}>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(4)}>
                                                                    <label>{Trad.Trad("Cellulare")}</label>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(4)}>
                                                                    <label>{Trad.Trad("Email")}</label>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(2)}>
                                                                </div>
                                                            </div>
                                                            <div className="row ">
                                                                <div className={Glob.DimensioneCSS(2)}>
                                                                    <h3 className="kt-portlet__head-title">{Trad.Trad(this.state.PolicyFileState)}</h3>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(4)}>
                                                                    <input type="text"
                                                                           className="form-control"
                                                                           name="Celullare"
                                                                           value={this.state.Phone}
                                                                           onChange={(e)=> this.setState({Phone: e.currentTarget.value})}>
                                                                    </input>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(4)}>
                                                                    <input type="text"
                                                                           className="form-control"
                                                                           name="Email"
                                                                           value={this.state.Email}
                                                                           onChange={(e)=> this.setState({Email: e.currentTarget.value})}>
                                                                    </input>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(2)}>
                                                                    <BottoneAPI
                                                                        Attivo={this.state.Phone.trim() != "" && this.state.Email.trim() != ""
                                                                            && this.state.PolicyFileState != Glob.Tipi_FS_Inviato
                                                                            && this.state.PolicyFileState != Glob.Tipi_FS_Firmato}
                                                                        Alt={Trad.Trad("Invia")}
                                                                        Icona="fa fa-pencil"
                                                                        Testo={Trad.Trad("Invia")}
                                                                        ClasseAttivo="btn btn-brand"
                                                                        ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                                        URL={"/api/File/SignaturePolicy"}
                                                                        Metodo="POST"
                                                                        OnInvio={() => this.OnSendPolicyToSignature()}
                                                                        OnClick={(s, d) => this.OnClickSendPolicyToSignature(s, d)}
                                                                        Visibile={this._Scrittura && this.state.PolicyFileState != Glob.Tipi_FS_Inviato}
                                                                    />
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(2)}>
                                                                    <BottoneAPI
                                                                        Alt={Trad.Trad("Cancella")}
                                                                        Icona="fa fa-trash"
                                                                        Testo={Trad.Trad("Cancella")}
                                                                        ClasseAttivo="btn btn-brand"
                                                                        ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                                        URL={"/api/File/Elimina?id_file=" + this.state.ID_File}
                                                                        Metodo="GET"
                                                                        OnClick={(s, d) => this.OnClickCancelSignature(s, d)}
                                                                        Visibile={isUnderwriter && this.state.PolicyFileState == Glob.Tipi_FS_Inviato}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                :<div/>
                            }
                        </div>
                    </div>
                </div>
                <div className="kt-portlet__foot kt-portlet__foot--fit">
                    <div className="kt-form login-form__actions kt-form login-form__actions--left">
                        <div className="modal fade" id="kt_modal_6" role="dialog" aria-labelledby="modalCartaServizi">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="exampleModalLongTitle">{Trad.Trad("Carta Servizi")}</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body col-lg-12">
                                        <div className="form-group kt-form login-form__group row">
                                            <div className={Glob.DimensioneCSS(4)}><button className="btn btn-brand" type="button" name="indice">{this._RichiestaCasella}</button></div>
                                            <div className={Glob.DimensioneCSS(2)}><input type="text" name="in1" value={this.state.in1} maxLength={1} className={"form-control text-center" + this.bloccoInput(this.state.in1Abl)} onChange={(e) => this.OnChange(e)} disabled={this.state.in1Abl} /></div>
                                            <div className={Glob.DimensioneCSS(2)}><input type="text" name="in2" value={this.state.in2} maxLength={1} className={"form-control text-center" + this.bloccoInput(this.state.in2Abl)} onChange={(e) => this.OnChange(e)} disabled={this.state.in2Abl} /></div>
                                            <div className={Glob.DimensioneCSS(2)}><input type="text" name="in3" value={this.state.in3} maxLength={1} className={"form-control text-center" + this.bloccoInput(this.state.in3Abl)} onChange={(e) => this.OnChange(e)} disabled={this.state.in3Abl} /></div>
                                            <div className={Glob.DimensioneCSS(2)}><input type="text" name="in4" value={this.state.in4} maxLength={1} className={"form-control text-center" + this.bloccoInput(this.state.in4Abl)} onChange={(e) => this.OnChange(e)} disabled={this.state.in4Abl} /></div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className={"btn btn-secondary " + this._VisibileScrittura} data-dismiss="modal">{Trad.Trad("Chiudi")}</button>
                                        <BottoneAPI Default Testo={Trad.Trad("Emetti")} URL={this.emettiURL()} Metodo="POST" OnClick={(s, d) => this.OnClickEmetti(s, d)} OnErrore={(s, e) => this.OnErrore(s, e)} DataDismiss="modal" Visibile={this._Scrittura} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-12 kt--align-left">
                                <div className="divtabella">
                                    <BottoneAPI Attivo={true} Alt={Trad.Trad("Consolida sottoscrittore")}
                                                Icona="fa fa-book-reader" Testo={Trad.Trad("Consolida sottoscrittore")}
                                                ClasseAttivo="btn btn-warning"
                                                ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                URL={"/api/polizza/ConsolidaPolizzaSottoscrittoreRCP?id_Polizza=" + this._ID_Polizza}
                                                Metodo="GET"
                                                OnClick={(s, d) => this.OnClickConsolidaSottoscrittore(s, d)}
                                                OnErrore={(s, e) => this.OnErrore(s, e)}
                                                Visibile={(this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_Consolidata || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_Approvata)
                                                    && Permesso_PS_Consolidata.indexOf(Glob.Tipi_PS_ConsolidataSottoscrittore) >= 0}/>
                                </div>
                                <div className="divtabella">
                                    <BottoneAPI Attivo={true} Alt={Trad.Trad("Salva")} Icona="fa fa-inbox"
                                                Testo={Trad.Trad("Salva")}
                                                ClasseAttivo={this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_Consolidata ? "btn btn-success" : "btn btn-success hidden"}
                                                ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                URL="/api/polizza/AggiornaListaPolizzaApprovazioneJSON" 
                                                Metodo="POST"
                                                OnInvio={(s) => this.OnAggiornaListaApprovazione(s)}
                                                OnClick={(s, d) => this.OnClickSalvaAggiornamento(s, d)}
                                                Visibile={this._Scrittura}/>
                                </div>
                                <div className="divtabella" data-toggle="modal" data-target="#kt_modal_6">
                                    <button type="button"
                                            className={this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_Approvata && !approvatore ? "btn btn-success" : "btn btn-success hidden"}
                                            title={"Emetti"}>
                                        <span>
                                            <i className="fa fa-thumbs-up"/>
                                            <span>{Trad.Trad("Emetti")}</span>
                                        </span>
                                    </button>
                                </div>

                            </div>
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-12 kt--align-left">
                                <div className="divtabella">
                                    <BottoneAPI Attivo={true} Alt={Trad.Trad("Cancella")} Icona="fa fa-times-circle"
                                                Testo={Trad.Trad("Cancella")} ClasseAttivo="btn btn-danger"
                                                ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                URL={"/api/polizza/ChangeStateToDraft?id_Polizza=" + this._ID_Polizza + "&allRecords=true"}
                                                Metodo="POST"
                                                OnClick={(s, d) => this.OnClickCancel(s, d)}
                                                OnErrore={(s, e) => this.OnErrore(s, e)}
                                                Visibile={this._Scrittura && (this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_Consolidata || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_Approvata)}/>
                                </div>
                                <div className="divtabella">
                                    <BottoneAPI Attivo={true} Alt={Trad.Trad("Disdetta")} Icona="fa fa-times-circle"
                                                Testo={Trad.Trad("Disdetta")} ClasseAttivo="btn btn-danger"
                                                ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                URL={"/api/Polizza/ChangeStateToTermination?idPolicy=" + this._ID_Polizza}
                                                Metodo="PUT"
                                                OnClick={(s, d) => this.OnClickTermination(s, d)}
                                                OnErrore={(s, e) => this.OnErrore(s, e)}
                                                Visibile={this._Scrittura && (this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_Emessa || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_Emessa_Firmata)}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <ChiamaAPI Aggiornare={this.state.Aggiorna} URL={"/api/polizza/?id_Polizza=" + this._ID_Polizza + "&id_AnagContraente=0"} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErrore} />
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/RCPPolizza.tsx